// The bar at the bottom (index.html .bar): each button's icon (public/icons.js) and text (a catalog key, public/i18n.js),
// per state, as data. The code that runs a button only says which state it's in:
//   setBar('share', 'live')   setBar('share')   (no state: the button's first one)
// and the bar draws itself again when the language changes (设置 → 语言). A new button: a line in BAR, its keys in
// public/locales/*.json (bar.<id>... ), and the <button id> in index.html. Only app.js imports it; another module
// needing setBar gets it from app.js's hooks (or imports it by the same URL: one instance).
import { label } from '/icons.js';
import { t, onLang } from '/i18n.js';

/** id -> { state: { icon, text } }; the first state is the one a button starts in. */
export const BAR = {
  call: { idle: { icon: 'phone', text: 'bar.call.idle' }, ringing: { icon: 'phone', text: 'bar.call.ringing' }, live: { icon: 'phone', text: 'bar.call.live' } },
  chat: { idle: { icon: 'chat', text: 'bar.chat' } },
  emote: { idle: { icon: 'emote', text: 'bar.emote' } },
  mic: {
    on: { icon: 'mic', text: 'bar.mic.on' },
    off: { icon: 'mic_off', text: 'bar.mic.off' },
    denied: { icon: 'mic_off', text: 'bar.mic.denied' }, // no permission for the mic
    none: { icon: 'mic_off', text: 'meeting.bar.mic.none' }, // no microphone found
    lost: { icon: 'mic_off', text: 'bar.mic.lost' }, // unplugged, and no other one to take
    down: { icon: 'mic_off', text: 'bar.mic.down' }, // voice couldn't connect
    busy: { icon: 'mic_off', text: 'bar.mic.busy' }, // the office refused new voice sessions for now: retried in 2 min
    previewWait: { icon: 'mic_off', text: 'bar.mic.previewWait' }, // a previous preview permission request is still settling
    reconnecting: { icon: 'mic_off', text: 'bar.mic.reconnecting' }, // my connection to the SFU was lost: publishing again (app.js voiceLost)
  },
  dress: { idle: { icon: 'shirt', text: 'bar.dress' } },
  arrange: { idle: { icon: 'desk', text: 'bar.arrange' } },
  share: { idle: { icon: 'screen', text: 'bar.share.idle' }, live: { icon: 'screen', text: 'bar.share.live' } },
  gather: { idle: { icon: 'flag', text: 'bar.gather' } },
  cast: { idle: { icon: 'megaphone', text: 'bar.cast.idle' }, live: { icon: 'megaphone', text: 'bar.cast.live' } },
};

const now = {}; // id -> its state
function draw(id) {
  const b = document.getElementById(id), states = BAR[id];
  if (!b || !states) return;
  const s = states[now[id]] ?? Object.values(states)[0];
  label(b, s.icon, t(s.text));
}
/** Put button `id` in `state` (one of its BAR states; none: its first). */
export function setBar(id, state) { now[id] = state; draw(id); }
/** Draw every button (once the bar is on the page), and again on every language change. */
export function initBar() {
  for (const id in BAR) draw(id);
  onLang(() => { for (const id in BAR) draw(id); });
}
